/**
 * Public landing page of Scan2Eat, served by web-client on `/`.
 *
 * A visitor who is not signed in lands there first, and reaches the sign-in
 * screen from its "Espace restaurant" links, which point to `/connexion`.
 * Without the variable in production, the back-office falls back to its own
 * sign-in screen. See docs/12-deploiement.md.
 */
export const VITRINE_URL: string | null =
  import.meta.env.VITE_VITRINE_URL || (import.meta.env.DEV ? 'http://localhost:5173/' : null);
